import PartnerDashboard   from '../pages/partner/Dashboard';
import PartnerBookings    from '../pages/partner/Bookings';
import PartnerServices    from '../pages/partner/Services';
import PartnerServiceForm from '../pages/partner/ServiceForm';
import PartnerTimings     from '../pages/partner/Timings';
import PartnerProfile     from '../pages/partner/Profile';
import PartnerNotifications from '../pages/partner/Notifications';

const partnerRoutes = [
  {
    path: '/partner/dashboard',
    component: PartnerDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/partner/bookings',
    component: PartnerBookings,
    meta: { requiresAuth: true },
  },
  {
    path: '/partner/services',
    component: PartnerServices,
    meta: { requiresAuth: true },
  },
  {
    path: '/partner/services/create',
    component: PartnerServiceForm,
    meta: { requiresAuth: true },
  },
  {
    path: '/partner/services/edit/:id',
    component: PartnerServiceForm,
    meta: { requiresAuth: true },
  },
  {
    path: '/partner/timings',
    component: PartnerTimings,
    meta: { requiresAuth: true },
  },
  {
    path: '/partner/profile',
    component: PartnerProfile,
    meta: { requiresAuth: true },
  },
  {
    path: '/partner/notifications',
    component: PartnerNotifications,
    meta: { requiresAuth: true },
  },
];

export default partnerRoutes;
